



import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";

const Mainnavbar = () => {
  const navigate = useNavigate();
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [savedAddresses, setSavedAddresses] = useState([]);

  // Get customer data
  const getCustomerId = () => localStorage.getItem("customerId");
  const getAuthToken = () => localStorage.getItem("authToken");

  // Load saved address on mount
  useEffect(() => {
    const saved = localStorage.getItem("selectedAddress");
    if (saved) {
      setSelectedAddress(saved);
    }
  }, []);


  return (
    <div className="mn-navbar">
      {/* TOP NAVBAR */}
      <header className="mn-top-navbar">
        <div className="mn-nav-left">
          <h2 className="mn-logo-text" onClick={() => navigate("/")}>
            <span className="mn-black">M</span>
            <span className="mn-red">aa</span>
            <span className="mn-black">maas</span>
          </h2>
        </div>

       
      </header>

      <style>{`
      /* Mainnavbar.css */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.mn-navbar {
  font-family: 'Inter', sans-serif;
  width: 100%;
}

/* Top Navbar */
.mn-top-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 15px rgba(230, 109, 51, 0.1);
  z-index: 1100;
  border-bottom: 1px solid rgba(230, 109, 51, 0.1);
}

/* Left side */
.mn-nav-left {
  display: flex;
  align-items: center;
}

.mn-logo-text {
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
  margin: 0;
  line-height: 1;
}

.mn-black {
  color: #333;
}

.mn-red {
  color: #e66d33;
}

/* Center - Location */
.mn-nav-center {
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: 500px;
  margin: 0 20px;
}

.mn-location-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fef6f2;
  border: 1px solid rgba(230, 109, 51, 0.2);
  border-radius: 40px;
  padding: 10px 20px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mn-location-btn:hover {
  background: #ffe8de;
  border-color: #e66d33;
  box-shadow: 0 5px 15px rgba(230, 109, 51, 0.2);
}

.mn-location-btn svg {
  color: #e66d33;
  font-size: 20px;
  flex-shrink: 0;
}

/* Right side */
.mn-nav-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.mn-nav-icon {
  color: #666;
  font-size: 26px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mn-nav-icon:hover {
  color: #e66d33;
  transform: scale(1.1);
}

/* Profile wrapper and dropdown */
.mn-profile-wrapper {
  position: relative;
}

.mn-profile-icon {
  color: #e66d33;
  font-size: 32px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mn-profile-icon:hover {
  transform: scale(1.1);
  filter: drop-shadow(0 5px 10px rgba(230, 109, 51, 0.3));
}

.mn-profile-dropdown {
  position: absolute;
  top: 45px;
  right: 0;
  width: 180px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1200;
  animation: slideDown 0.2s ease;
  border: 1px solid rgba(230, 109, 51, 0.1);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mn-dropdown-item {
  padding: 12px 20px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mn-dropdown-item:hover {
  background: #fef6f2;
  color: #e66d33;
}

/* Location Popup */
.mn-location-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(5px);
}

.mn-location-popup {
  background: white;
  width: 450px;
  max-width: 90%;
  border-radius: 24px;
  padding: 24px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: popupSlideUp 0.3s ease;
}

@keyframes popupSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mn-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.mn-popup-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #333;
}

.mn-close-popup-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  transition: all 0.2s ease;
}

.mn-close-popup-btn:hover {
  color: #e66d33;
  transform: scale(1.1);
}

.mn-search-container {
  margin-bottom: 20px;
}

.mn-popup-search-input {
  width: 100%;
  padding: 14px 18px;
  border: 2px solid #f0f0f0;
  border-radius: 16px;
  font-size: 15px;
  transition: all 0.3s ease;
  outline: none;
}

.mn-popup-search-input:focus {
  border-color: #e66d33;
  box-shadow: 0 0 0 4px rgba(230, 109, 51, 0.1);
}

.mn-option-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fef9f5;
  border-radius: 18px;
  padding: 20px;
  border: 1px solid rgba(230, 109, 51, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.mn-option-box:hover {
  background: #ffe8de;
  border-color: #e66d33;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(230, 109, 51, 0.15);
}

.mn-option-title {
  margin: 0 0 5px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.mn-option-desc {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.mn-enable-btn {
  background: white;
  border: 1px solid #e66d33;
  color: #e66d33;
  padding: 8px 20px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.mn-enable-btn:hover:not(:disabled) {
  background: #e66d33;
  color: white;
  transform: scale(1.05);
}

.mn-enable-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mn-error-message {
  color: #ff4d4f;
  font-size: 14px;
  text-align: center;
  margin-top: 15px;
  padding: 10px;
  background: #fff2f0;
  border-radius: 12px;
  border: 1px solid #ffccc7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mn-top-navbar {
    padding: 0 15px;
  }

  .mn-logo-text {
    font-size: 26px;
  }

  .mn-nav-center {
    max-width: 200px;
  }

  .mn-location-btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  .mn-location-btn svg {
    font-size: 16px;
  }

  .mn-nav-right {
    gap: 10px;
  }

  .mn-nav-icon {
    font-size: 22px !important;
  }

  .mn-profile-icon {
    font-size: 28px !important;
  }

  .mn-location-popup {
    width: 90%;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .mn-nav-center {
    max-width: 150px;
  }

  .mn-location-btn span {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/* Focus visible for accessibility */
:focus-visible {
  outline: 3px solid #e66d33;
  outline-offset: 2px;
}

/* Selection color */
::selection {
  background: #e66d33;
  color: white;
}`}</style>
    </div>
  );
};

export default Mainnavbar;